<template>
	<div >
		<ConfirmDialog></ConfirmDialog>
		
		<ConfirmDialog group="demo">
			<template #message="slotProps">
				<div class="flex p-4">
					<i :class="slotProps.message.icon" style="font-size: 1.5rem"></i>
					<p class="pl-2">{{ slotProps.message.message }}</p>
				</div>
			</template>
		</ConfirmDialog>
		
		<Toast position="top-left" />
		
		<TheLogo v-if="$route.meta.layout !== 'blank'"/>
	</div>
	
	<router-view :key="$route.fullPath"/>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import router from "@/router";
	import store from "@/store";

	import TheLogo from "@/components/TheLogo.vue";
	
	export default defineComponent({
		components: {
			// TheLogo
		},
		mounted: function () {
			switch (performance.navigation.type) {
				case 1:
					store.dispatch("session")
						.catch(error => {
							store.dispatch("clearSession");
							if (router.currentRoute.value.fullPath == "/forgotpassword" || router.currentRoute.value.fullPath == "/register") {
								router.push(router.currentRoute.value.fullPath);
							}
							
							else {
								router.push("/login");
							}
						})
					break;
			}
		}
	});
</script>